export class HastaDosyalariListeIstek {
    kimlikId?: number = null;
    dokumanId?: number = null;
    muracaatId?: number = null;
    hastaServisId?: number = null;
    baslangicTarih?: string = null;
    bitisTarih?: string = null;
    dokumanTurId?: number = null;
    mobilKontrol?: string = "H";
};

export class IYuklenecekDokumanlar {
    id?: number = 0;
    hastaDokumanId?: number = null;
    muracaatId?: number = null;
    hastaServisId?: number = null;
    mobilYukleme?: string = "H";
    dokumanAdi?: string = "";
    dokumanUzanti?: string = "";
    dokumanAciklama?: string = "";
    dokumanturId?: number = null;
    dokumanBlob?: string = "";

    yatisdurumId?: number = null;
    bolgeId?: number = null;
    bolgeaciklama?: string = "";
    evreId?: number = null;
    basiyaraYeniyara?: string = "H";
    basiyaraEnCm?: number = null;
    basiyaraBoyCm?: number = null;
    basiyaraDerinlikCm?: number = null;
    basiyaraAciklama?: string = "";
    basiyaraIlkyaratarih?: string = null;
    cerrahiIslemgun?: number = null;
}

export class HastaDetayDosyalariListeIstek {
    kimlikId?: number = null;
    dokumanDetayId?: number = null;
    hastaDokumanId?: number = null;
}

export class HastaDosyaViewerCevap {
    belgeAdi?: string = "";
    belgeIcerik?: string = "";
}